<template>
  <v-card flat class="v-userlist">
    <v-toolbar dense flat color="transparent">
      <v-toolbar-title class="ma-0 subheading">{{ group.display }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon small @click="showSearch = !showSearch">
        <v-icon small>{{ $vuetify.icons.values.search }}</v-icon>
      </v-btn>
      <AddUserAttribution :handleSubmit="add" :multiple="true" isIconBtn />
      <v-btn icon small @click="destroyGroup" v-if="!group.system">
        <v-icon small>{{ $vuetify.icons.values.cancel }}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-0">
      <v-divider />
      <v-expand-transition>
        <SingleSearchFilter
          transition="slide-y-transition"
          :context="context"
          class-name="px-3 pt-0"
          v-if="showSearch"
          :fields="searchFields"
        />
      </v-expand-transition>
      <v-divider v-if="showSearch" />
      <v-data-table
        flat
        :headers="headers"
        :items="members"
        :loading="loading"
        :server-items-length="usersCount"
        :page.sync="page"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items-per-page.sync="itemsPerPage"
        :footer-props="{ itemsPerPageOptions: itemsPerPageArray }"
        hide-default-header
        class="elevation-0"
      >
        <template v-slot:item="{ item }">
          <UserLine :group-user="item" :add="add" :destroy="destroy" allow-self-removal allow-owner-removal />
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { create } from 'vue-modal-dialogs'
import { SingleSearchFilter } from '@argon/app/components'
import { AddUserAttribution } from '@argon/iam/components'
import { Datatable } from '@argon/app/mixins'

import { NAMESPACE, GROUP_USERS } from '../store'
import groupPerimeter from '../perimeters'

import ConfirmRemoveGroupDialog from './ConfirmRemoveGroupDialog'
import UserLine from './UserLine'
const confirmDeleteAction = create(ConfirmRemoveGroupDialog)

export default {
  name: 'GroupUsers',
  components: {
    AddUserAttribution,
    SingleSearchFilter,
    UserLine
  },
  mixins: [Datatable],
  perimeters: [groupPerimeter],
  props: {
    group: { type: Object, required: true },
    attributions: { type: Array, required: true }
  },
  data: () => ({
    headers: [{ value: 'display' }, { value: 'attributionName' }, { value: 'action' }],
    filterString: null,
    showSearch: false,
    loading: false,
    searchFields: [{ label: 'display', type: 'text' }],
    context: GROUP_USERS
  }),
  computed: {
    ...mapState(NAMESPACE, ['users']),
    groupUsers() {
      return this.users[this.group.refname] ? this.users[this.group.refname].items : []
    },
    usersCount() {
      return this.users[this.group.refname] ? this.users[this.group.refname].count : 0
    },
    members() {
      return this.groupUsers.map((match) => {
        const attribution = this.attributions.find((attr) => attr.value === match.attribution)
        return {
          ...match,
          attributionName: attribution ? attribution.name : 'LEAST'
        }
      })
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['addPrincipals', 'deletePrincipals', 'deleteGroup', 'listGroupUsers']),
    add(payload) {
      return this.addPrincipals({ ...payload, groupRef: this.group.refname }).then(() => {
        this.fetchData()
      })
    },
    destroy(payload) {
      return this.deletePrincipals({
        principalIds: [payload],
        groupRef: this.group.refname
      }).then(() => {
        this.fetchData()
      })
    },
    destroyGroup() {
      return confirmDeleteAction().then((res) => {
        if (res) {
          this.deleteGroup(this.group.refname)
        }
      })
    },
    fetchData() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.listGroupUsers({ groupRef: this.group.refname, pager: this.pager })
          .then(resolve)
          .catch(reject)
          .finally(() => {
            this.loading = false
          })
      })
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped lang="scss">
.v-toolbar {
  ::v-deep .v-toolbar__content {
    padding: 0 16px;

    .v-btn--icon {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>
